import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../shared/utils/api.js'

export const login = createAsyncThunk('auth/login', async (credentials, { rejectWithValue }) => {
  try {
    const response = await api.post('/v1/admin/login', credentials)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

export const register = createAsyncThunk('auth/register', async (userData, { rejectWithValue }) => {
  try {
    const response = await api.post('/v1/admin/create', userData)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const logout = createAsyncThunk('auth/logout', async rejectWithValue => {
  try {
    const response = await api.post('/v1/admin/logout')
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const updatePassword = createAsyncThunk('auth/updatePassword', async (passwordData, { rejectWithValue }) => {
  try {
    const response = await api.post('/v1/admin/settings/password', passwordData)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})
